import {
  getFirestore,
  collection,
  addDoc,
  Timestamp,
} from "firebase/firestore";
import sendErrorDiscord from "./sendErrorDiscord.js"; // Assuming a custom log function similar to FlutterFlow
import { useState } from "react";
import { getDoc, doc } from "firebase/firestore";
import { checkDB, getDocDataById } from "../models/DataFunctions";

const addLogDocument = async (
  url,
  prefix = "https://api.hexagone.expert/",
  user_ref,
  org_id,
  status,
  folderid,
  docid,
  request,
  response,
  type = "POST",
  delay = 0
) => {
  let start = new Date();
  const db = getFirestore(); // Initialize Firestore
  console.log("Adding log document to Firestore", org_id);
  let email = "";
  if (org_id) {
    const orgData = await getDocDataById("org", org_id);

    email = orgData.infos?.email || "";
  }

  // Create the log document object
  const logDocument = {
    url: url,
    user_id: user_ref ? user_ref.id : "",
    org_id: org_id || "",
    type: type,
    email: email,
    status: status,
    date: Timestamp.now(), // Firestore timestamp
    folderid: folderid || "",
    docid: docid || "",
    request: request || "",
    response: response || "",
    resolved: false, // Default resolved state
    delay: delay,
  };
  console.log("Log document to be added:", logDocument);

  try {
    // Send error to Discord if status is not 200

    if (
      status.toString() !== "200" &&
      // prefix does not have localhost
      !prefix.includes("localhost")
    ) {
      await sendErrorDiscord(
        `ERROR ${status} on endpoint: ${url}, response: ${
          response || ""
        }, email: ${email}`,
        prefix
      );
      // Assuming you have an app state management system
      // FFAppState().error = true; can be translated to your React state management system
    }

    // Add the log document to the Firestore collection 'log'
    await addDoc(collection(db, "log"), logDocument);
    let end = new Date();
    let elapsed = end - start;
    return "Log document added successfully";
  } catch (error) {
    console.error("Error adding log document:", error);
    return `Error adding log document: ${error.message}`;
  }
};

export default addLogDocument;
